import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import type React from "react";
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useSupabaseSession } from "@/hooks/useSupabaseSession";
import { supabase } from "@/lib/supabaseClient";

const AuthPage: React.FC = () => {
	const { session, isLoading } = useSupabaseSession();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		if (!isLoading && session) {
			const next = searchParams.get("next");
			window.location.href = next?.startsWith("/") ? next : "/app";
		}
	}, [isLoading, searchParams, session]);

	const redirectTo = `${window.location.origin}/auth`;

	const supabaseAppearance = {
		theme: ThemeSupa,
		variables: {
			default: {
				colors: {
					brand: "#0284c7",
					brandAccent: "#0369a1",
					inputText: "var(--text)",
					inputBorder: "var(--border)",
					defaultButtonBackground: "var(--surface-2)",
					defaultButtonHoverBackground: "var(--surface-3)",
					defaultButtonBorder: "var(--border)",
					messageBackground: "var(--surface-3)",
					messageBackgroundDanger: "var(--surface-3)",
				},
			},
		},
	};

	const additionalDataRef = useRef<{ name: string; full_name: string }>({
		name: "",
		full_name: "",
	});
	const nameValueRef = useRef("");

	return (
		<div className="min-h-screen surface flex">
			<div className="relative hidden lg:block lg:w-1/2 overflow-hidden">
				<div className="absolute inset-0 bg-gradient-to-br from-primary-700 via-primary-600 to-indigo-700" />
				<div className="absolute inset-0 opacity-25 bg-[radial-gradient(circle_at_20%_20%,white,transparent_45%),radial-gradient(circle_at_80%_30%,white,transparent_35%),radial-gradient(circle_at_40%_80%,white,transparent_40%)]" />
				<div className="relative h-full flex items-end p-12">
					<div className="max-w-lg text-white">
						<div className="text-sm tracking-widest uppercase opacity-80">KnowGem</div>
						<h1 className="mt-4 text-4xl font-semibold leading-tight">Sign in to continue.</h1>
						<p className="mt-4 text-base opacity-80">Welcome to your journey to find your knowledge gem.</p>
					</div>
				</div>
			</div>

			<div className="flex-1 flex items-center justify-center p-6 surface">
				<div className="w-full max-w-md">
					<div className="card p-6">
						<div className="flex items-center justify-between">
							<h2 className="text-2xl font-semibold">Welcome</h2>
							<a href="/app" className="text-sm text-subtle hover-text">
								Back
							</a>
						</div>

						<div className="mt-6">
							<Auth
								supabaseClient={supabase}
								appearance={supabaseAppearance}
								providers={["google"]}
								redirectTo={redirectTo}
								magicLink
								additionalData={additionalDataRef.current}
							>
								<div>
									<label htmlFor="name" className="supabase-auth-ui_ui-label c-bpexlo">
										Name
									</label>
									<input
										id="name"
										className="supabase-auth-ui_ui-input c-dEnagJ c-dEnagJ-bBzSYw-type-default"
										onChange={(e) => {
											const v = e.target.value;
											nameValueRef.current = v;
											additionalDataRef.current.name = v;
											additionalDataRef.current.full_name = v;
										}}
										placeholder="Name"
										autoComplete="name"
									/>
								</div>
							</Auth>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AuthPage;
